module.exports = __webpack_public_path__ + "img/individuelles_anfertigung_button.3d28bc80.jpg";